import React from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle
} from "../../shared/ui/components/dialog";
import { Button } from "../../shared/ui/components/button";
import { AlertTriangle } from "lucide-react";
import { DocumentDto } from "../types";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  document: DocumentDto | null;
  isDeleting: boolean;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  document,
  isDeleting
}) => {
  return (
    <Dialog open={isOpen} onOpenChange={onClose}>
      <DialogContent
        className="sm:max-w-[425px]"
        aria-describedby="delete-dialog-description"
      >
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <AlertTriangle className="h-5 w-5 text-destructive" />
            Delete Document
          </DialogTitle>
          <DialogDescription id="delete-dialog-description">
            This action cannot be undone. The document will be permanently
            removed.
          </DialogDescription>
        </DialogHeader>

        <div className="py-4">
          {document && (
            <div className="bg-muted p-4 rounded-md">
              <p className="text-sm font-medium mb-1">Document to delete:</p>
              <p className="text-sm text-foreground font-semibold truncate">
                {document.filename}
              </p>
              {document.comments && (
                <p className="text-xs text-muted-foreground mt-2 line-clamp-2">
                  {document.comments}
                </p>
              )}
            </div>
          )}
          <p className="text-sm text-muted-foreground mt-4">
            Are you sure you want to delete this document?
          </p>
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} disabled={isDeleting}>
            Cancel
          </Button>
          <Button
            variant="destructive"
            onClick={onConfirm}
            disabled={isDeleting}
          >
            {isDeleting ? "Deleting..." : "Delete Document"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default DeleteConfirmationModal;
